import React from 'react';
import { RouteComponentProps } from 'react-router';

import SesamLink from 'Common/Links/SesamLink';
import { PermissionsEditor } from 'Common/PermissionsEditor';

export const PipePermissions: React.FC<RouteComponentProps<{}, any>> = (props) => {
  const { pipeID, subId } = props.params;

  return (
    <div className="scrollArea">
      <p>
        These settings inherit their default values from the{' '}
        <SesamLink to={`/subscription/${subId}/pipes/prototype-permissions`}>
          pipe prototype settings
        </SesamLink>
        .
      </p>
      <PermissionsEditor permissionPath={['pipes', pipeID]} />
    </div>
  );
};
